import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetSourceProjectResponse } from "interfaces";

const initialState = {
  header: {
    name: "",
    isPreferred: false,
    type: "SHARED",
  },
  count: 0,
  loaded: false,
  listSourceProject: {
    codesList: [],
    sourcesList: [],
    privateSourcesList: [],
  } as GetSourceProjectResponse,
  listSourceProjectFiltered: {
    codesList: [],
    sourcesList: [],
    privateSourcesList: [],
  } as GetSourceProjectResponse,
};

const gestioneDetailProjectSlice = createSlice({
  name: "gestioneDetailProjectSlice",
  initialState,
  reducers: {
    setHeaderDetailProject: (state, action) => {
      state.header = action.payload;
    },
    setSourceProject: (state, action) => {
      state.listSourceProject = action.payload;
      state.listSourceProjectFiltered = action.payload;
      state.loaded = true;
    },
    setNameProject: (state, action) => {
      state.header.name = action.payload;
    },
    setCountChecked: (state, action) => {
      state.count = action.payload;
    },
    updateSourceProject: (
      state,
      action: PayloadAction<{
        listName: keyof GetSourceProjectResponse;
        source: any;
      }>
    ) => {
      const { listName, source } = action.payload;
      if (source.id) {
        state.listSourceProject[listName] = state.listSourceProject[
          listName
        ].map((item: any) =>
          item.id === source.id ? source : item
        ) as (typeof state.listSourceProject)[keyof GetSourceProjectResponse];
      } else {
        state.listSourceProject[listName] = state.listSourceProject[
          listName
        ].filter(
          (item: any) => item.id !== source
        ) as (typeof state.listSourceProject)[keyof GetSourceProjectResponse];
      }
      state.listSourceProjectFiltered[listName] =
        state.listSourceProject[listName];
    },
    addSourceProject: (
      state,
      action: PayloadAction<{
        listName: keyof GetSourceProjectResponse;
        source: any;
      }>
    ) => {
      const { listName, source } = action.payload;
      state.listSourceProject[listName].push(source);
      state.listSourceProjectFiltered[listName] =
        state.listSourceProject[listName];
    },
    setFilterSource: (state, action) => {
      const keyword = action.payload.toLowerCase();
      state.listSourceProjectFiltered = {
        codesList: state.listSourceProject.codesList.filter((source: any) =>
          source.name.toLowerCase().includes(keyword)
        ),
        sourcesList: state.listSourceProject.sourcesList.filter((source: any) =>
          source.name.toLowerCase().includes(keyword)
        ),
        privateSourcesList: state.listSourceProject.privateSourcesList.filter(
          (source: any) => source.name.toLowerCase().includes(keyword)
        ),
      };
    },
    resetLoadedStatus: (state: any) => {
      state.loaded = false;
    },
    resetInitialStateDetailProject: (state) => initialState,
  },
});

export const {
  setHeaderDetailProject,
  setNameProject,
  setSourceProject,
  setFilterSource,
  addSourceProject,
  updateSourceProject,
  resetLoadedStatus,
  resetInitialStateDetailProject,
  setCountChecked,
} = gestioneDetailProjectSlice.actions;

export default gestioneDetailProjectSlice.reducer;
